<script>
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';

export default {
  components: {
    Twilio,
    BandwidthSms,
  },
  data() {
    return {
      provider: 'twilio',
    };
  },
};
</script>

<template>
  <div class="sms-page h-full w-full overflow-y-auto">
    <div class="ch-form-page">
      <div class="ch-form-page__intro">
        <h2 class="ch-form-page__title">
          {{ $t('INBOX_MGMT.ADD.SMS.TITLE') }}
        </h2>
        <p class="ch-form-page__desc">{{ $t('INBOX_MGMT.ADD.SMS.DESC') }}</p>
      </div>

      <!-- Provider select -->
      <div class="ch-form-row">
        <div class="ch-form-row__label-col">
          <label class="ch-form-label">{{
            $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL')
          }}</label>
        </div>
        <div class="ch-form-row__control-col">
          <select v-model="provider" class="ch-select">
            <option value="twilio">
              {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.TWILIO') }}
            </option>
            <option value="360dialog">
              {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.BANDWIDTH') }}
            </option>
          </select>
        </div>
      </div>

      <!-- Sub-form -->
      <div class="sms-subform">
        <Twilio v-if="provider === 'twilio'" type="sms" />
        <BandwidthSms v-else />
      </div>
    </div>
  </div>
</template>

<style scoped>
.sms-page {
  background: #ffffff;
}

.ch-form-page {
  padding: 28px 32px 80px;
  max-width: 860px;
  background: #ffffff;
  box-sizing: border-box;
}
.ch-form-page__intro {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e5e7eb;
}
.ch-form-page__title {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 6px;
}
.ch-form-page__desc {
  font-size: 13px;
  color: #4b5563;
  margin: 0;
}

.ch-form-row {
  display: flex;
  gap: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #f3f4f6;
}
.ch-form-row__label-col {
  width: 240px;
  flex-shrink: 0;
}
.ch-form-row__control-col {
  flex: 1;
  min-width: 0;
}

.ch-form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px;
}

.ch-select {
  display: block;
  width: 100%;
  max-width: 400px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  color: #111827;
  outline: none;
  cursor: pointer;
}
.ch-select:focus {
  border-color: #0066ff;
  box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.1);
}

/* Force sub-form (Twilio / BandwidthSms) labels to be readable */
.sms-subform :deep(label) {
  color: #111827 !important;
}
.sms-subform :deep(input) {
  background: #ffffff !important;
  border-color: #d1d5db !important;
  color: #111827 !important;
}
.sms-subform :deep(.message) {
  color: #ef4444 !important;
}
</style>
